import { Component, Input, OnInit, inject } from '@angular/core';
import { TakeUntilDestroy } from '@shared/decorators/take-until-destroy.decorator';
import { Modal, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { EventManager } from '@app/shared/utils/event-manager';
import { LoggerService } from '@app/shared/services/logger.service';
import { Ranking } from '@app/shared/models/ranking.model';
import { Display, FontSizeRescalerService } from '@app/shared/services/font-rescaler.service';
import { NgClass, DecimalPipe } from '@angular/common';
import { ParagraphComponent } from '@shared/components/text/p/p.component';
import { AvatarComponent } from '@shared/components/avatar/avatar.component';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { UserRepository } from '@app/shared/state/user/user.repository';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-ranking-item',
  templateUrl: './ranking-item.component.html',
  styleUrls: ['./ranking-item.component.scss'],
  standalone: true,
  imports: [NgClass, ParagraphComponent, AvatarComponent, DecimalPipe, TranslateModule],
})
export class RankingItemComponent implements OnInit {
  private userRepo = inject(UserRepository);
  private eventManager = inject(EventManager);
  logger = inject(LoggerService);
  private fontSizeRescalerService = inject(FontSizeRescalerService);

  @Input() ranking: Ranking;
  @Input() isFriends: boolean;
  @Input() showMedals?: boolean = true;
  @Input() hideReward?: boolean = false;

  isSelf: boolean;
  styleClass: string;
  prizeValue: number;
  prizeType: number;
  componentDestroy: () => Observable<unknown>;

  ngOnInit() {
    this.getPrize();
    this.isSelf = this.ranking.userId == this.userRepo.getId();
    // eslint-disable-next-line
    this.isSelf ? (this.styleClass = 'self-container') : (this.styleClass = 'item-container');
    // eslint-disable-next-line
    this.hideReward ? (this.styleClass += ' hidden-reward') : this.styleClass;
  }

  publicProfile() {
    if (!this.isSelf) {
      this.eventManager.openModal(
        new Modal(
          NonPersistedModalName.PublicProfileComponent,
          ModalType.View,
          { userId: this.ranking.userId },
          'big-dialog'
        )
      );
    }
  }

  getPosition(ranking: Ranking): string {
    if (ranking.rankingPosition == 1) {
      return 'first';
    }
    if (ranking.rankingPosition == 2) {
      return 'second';
    }
    if (ranking.rankingPosition == 3) {
      return 'third';
    }

    if (ranking.rankingPosition > 3 && ranking.rankingPosition <= 10) {
      return 'top-10';
    }

    return 'other';
  }

  setFontSize(rankingPosition: number): number {
    return Number(this.fontSizeRescalerService.setFontSize(Display.RankingPosition, rankingPosition));
  }

  private getPrize(): void {
    if (this.ranking.prize.credits > 0) {
      this.prizeValue = this.ranking.prize.credits;
      this.prizeType = 1;
    } else {
      this.prizeValue = this.ranking.prize.gems;
      this.prizeType = 2;
    }
  }
}
